import { render, staticRenderFns } from "./PathwayCohortView.vue?vue&type=template&id=1c025807&"
import script from "./PathwayCohortView.vue?vue&type=script&lang=js&"
export * from "./PathwayCohortView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports